import { useMemo } from 'react';
import { getCurrentRole, getPermissions, RolePermissions } from '../utils/permissions';

/**
 * usePermissions — 현재 사용자의 권한 플래그를 안정된 객체로 반환.
 *
 * 사용 :
 *   const { canEdit, isAdmin } = usePermissions();
 *   {canEdit && <SaveButton />}
 *   {isAdmin && <DeleteButton />}
 *
 * 주의 :
 *   localStorage 기반 role 이라 다른 탭에서 로그아웃 / 다른 사용자 로그인 발생시
 *   이 hook 은 자동 재렌더링되지 않는다. 다른 탭 동기화가 중요해지면 storage
 *   event listener 를 추가할 것 — 현재는 단일 탭 운영 가정.
 */
export const usePermissions = (): RolePermissions => {
  return useMemo(() => getPermissions(getCurrentRole()), []);
};

export default usePermissions;
